import CreateCompany from "../../../../components/forms/propertyForm/index";
import { useSelector } from "react-redux";
import { SuccessNotify, FailedNotify } from "../../../../constants/tostify";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Loader from "../../../../components/Loader";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { useCreateCompanyMutation } from "../../../../features/user/userApiSlice";
import { useGetShopCategoriesQuery } from "../../../../features/shop/shopApiSlice";

const CreateCompanyForm = () => {
  const navigate = useNavigate();
  const [displayimg, setDisplayimg] = useState();
  const { name } = useSelector((state) => state.user);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const userId = name._id;

  const [data, setData] = useState({
    shopCategory: "",
  });

  const Handledata = (e) => {
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = data?.shopCategory[1];
  const categoryid = data.shopCategory[0];
  localStorage.setItem("mycategory", categoryName);

  useEffect(() => {
    setValues((values) => ({
      ...values,
      shopCategoryid: categoryid,
      shopCategory: categoryName,
    }));
  }, [categoryid, categoryName]);

  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });

      setValues((values) => ({
        ...values,
        image: abc,
      }));

      setDisplayimg(abc);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const [values, setValues] = useState({
    userid: userId,
    companyname: "",
    companyaddress: "",
    companylicense: "",
    contactnumber: "",
    shopCategory: "",
    shopCategoryid: "",
    description: "",
    marketPlace: "",
    image: [""],
    isBusinessProperty: "false",
    isJobsCompany: "true",
    businessType: "jobsCompany",
  });

  // RTK Query: fetch categories
  const { data: categoriesData } = useGetShopCategoriesQuery({
    type: "company",
    parentCategory: "",
  });
  const shopCategoryone = categoriesData?.data?.Category || [];

  // RTK Query: create company mutation
  const [createCompanyMutation, { isLoading: isloading }] =
    useCreateCompanyMutation();

  const formSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await createCompanyMutation(values).unwrap();
      if (response?.success) {
        setTimeout(() => {
          SuccessNotify("Company-form Created SuccesFully...");
          navigate(`/company-business-Profile/${response?.data?._id}`);
        }, 1000);
      }
    } catch (error) {
      const backendMessage =
        error?.data?.message || error?.message || "Failed to Create Company!";
      FailedNotify(backendMessage);
    }
  };

  if (isloading) {
    return <Loader heightsetting="screenHeight" />;
  }

  return (
    <div>
      <CreateCompany
        heading="Fill to Create Company Profile"
        Buttn="Create"
        name="Company Name"
        address="Company Address"
        Handledata={Handledata}
        url="/company-profile"
        back="/SellingSide"
        setValues={setValues}
        values={values}
        dataHandler={formSubmit}
        shopCategoryone={shopCategoryone}
        getInputProps={getInputProps}
        getRootProps={getRootProps}
        displayimg={displayimg}
        setDisplayimg={setDisplayimg}
        isUploading={isUploading}
        uploadProgress={uploadProgress}
      />
    </div>
  );
};

export default CreateCompanyForm;
